import { render, staticRenderFns } from "./person-approve.vue?vue&type=template&id=1a664111&scoped=true&"
import script from "./person-approve.vue?vue&type=script&lang=js&"
export * from "./person-approve.vue?vue&type=script&lang=js&"
import style0 from "./person-approve.vue?vue&type=style&index=0&id=1a664111&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a664111",
  null
  
)

export default component.exports